module.exports = __webpack_public_path__ + "static/media/outstanding.c8da5f6b.svg";